<script setup lang="ts">
import Accordion from 'primevue/accordion';
import AccordionTab from 'primevue/accordiontab';
import Timeline from 'primevue/timeline';
import TimelineMarker from './timeline/TimelineMarker.vue';
import TimelineConnector from './timeline/TimelineConnector.vue';

interface TimelineItem {
  title: string;
  body: string;
}

interface Props {
  header: string;
  data: TimelineItem[];
}

defineProps<Props>();

const emit = defineEmits<{
  'accordion-expanded': [];
}>();
</script>

<template>
  <div class="accordion">
    <Accordion @tab-open="emit('accordion-expanded')">
      <AccordionTab :header="header">
        <Timeline :value="data" class="timeline">
          <template #content="slotProps">
            <div class="timeline-step-container">
              <span class="step-heading">{{ slotProps.item.title }}</span>
              <br />
              <span class="step-description">{{ slotProps.item.body }}</span>
            </div>
          </template>
          <template #marker="slotProps">
            <TimelineMarker color="#a36bff" />
          </template>

          <template #connector>
            <TimelineConnector color="#f0e7ff" />
          </template>
        </Timeline>
      </AccordionTab>
    </Accordion>
  </div>
</template>

<style lang="less" scoped>
.accordion {
  :deep(.p-accordion .p-accordion-header .p-accordion-header-link) {
    display: flex;
    justify-content: space-between;
    color: #000000 !important;
    background: transparent !important;
    box-shadow: none !important;
    padding: 0;
    border: 0;
    border-radius: 0;
    font-size: 16px;
    font-weight: 500;
  }

  :deep(.p-accordion-header .p-accordion-header-text) {
    order: 1;
  }

  :deep(.p-accordion-toggle-icon) {
    order: 2;
  }

  :deep(.p-accordion .p-accordion-content) {
    padding: 24px 0 0 0;
    border: 0;
    border-radius: 0;
  }

  :deep(.p-timeline-event) {
    display: flex;
    min-height: 0;
  }

  :deep(.p-timeline-event-opposite) {
    display: none;
  }

  :deep(.p-timeline-left .p-timeline-event-content) {
    margin-bottom: 40px;
  }

  :deep(
    .p-timeline-left .p-timeline-event:last-child .p-timeline-event-content
  ) {
    margin-bottom: 0;
  }
}

.timeline-step-container {
  font-family: @regular-font;
  color: black;
  margin-top: -6px;

  .step-heading {
    line-height: 24px;
    font-size: 15px;
    font-weight: 500;
  }
  .step-description {
    line-height: 20px;
    font-size: 13px;
    font-weight: 400;
  }
}
</style>
